import { makeStyles } from "@mui/styles";

const useStyles = makeStyles(() => ({
  sidemenus: {
    paddingLeft: "0",
    "& li": {
      padding: "10px 15px",
      cursor: "pointer",
      "&:hover": {
        backgroundColor: "#f8f9fa",
      },
    },
  },
}));

export default useStyles;